<form class="list-filters" [formGroup]="form" (ngSubmit)="applyNow()">
  <div class="list-filters__grid">
    <!-- Search -->
    <mat-form-field
      *ngIf="config.search"
      appearance="outline"
      class="list-filters__field list-filters__field--search"
    >
      <mat-label>Search</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input
        matInput
        formControlName="search"
        [placeholder]="searchPlaceholder"
        autocomplete="off"
      />
    </mat-form-field>

    <!-- Date range -->
    <ng-container *ngIf="config.dateRange">
      <mat-form-field appearance="outline" class="list-filters__field">
        <mat-label>Start date</mat-label>
        <input
          matInput
          formControlName="from"
          [matDatepicker]="fromPicker"
        />
        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="list-filters__field">
        <mat-label>End date</mat-label>
        <input matInput formControlName="to" [matDatepicker]="toPicker" />
        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>
    </ng-container>

    <!-- Select dropdowns (status, payment method, ...) -->
    <mat-form-field
      *ngFor="let select of config.selects"
      appearance="outline"
      class="list-filters__field"
    >
      <mat-label>{{ select.label }}</mat-label>
      <mat-select [formControlName]="select.key">
        <mat-option value="">{{ select.allLabel || 'All' }}</mat-option>
        <mat-option *ngFor="let opt of select.options" [value]="opt.value">
          {{ opt.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Amount range -->
    <ng-container *ngIf="config.amountRange">
      <mat-form-field appearance="outline" class="list-filters__field">
        <mat-label>Minimum amount</mat-label>
        <input
          matInput
          type="number"
          min="0"
          formControlName="minAmount"
          placeholder="0"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" class="list-filters__field">
        <mat-label>Maximum amount</mat-label>
        <input
          matInput
          type="number"
          min="0"
          formControlName="maxAmount"
          placeholder="0"
        />
      </mat-form-field>
    </ng-container>

    <!-- Actions -->
    <div class="list-filters__actions">
      <button
        mat-icon-button
        type="button"
        matTooltip="Clear filters"
        [disabled]="!hasActiveFilters"
        (click)="reset()"
      >
        <mat-icon>filter_alt_off</mat-icon>
      </button>
      <button
        mat-icon-button
        color="primary"
        type="submit"
        matTooltip="Apply filters"
      >
        <mat-icon>search</mat-icon>
      </button>
    </div>
  </div>
</form>
